import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FundraiserComponent } from './components/fundraiser/fundraiser.component';

const routes: Routes = [
  {
    path: ':tag',
    component: FundraiserComponent,
    data: {
      eventName: 'pageView',
      page_name: 'campaign',
      category: 'fundraising',
      lastOrderSkip: false
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FundraiserRoutingModule { }
